export default function Council2026Entries() {
  return (
    <table id="filetable">
      {/*Start Table*/}
      <tr>
        <th id="a-m">Meeting Date</th>
        <th>Minutes</th>
        <th>Agenda</th>
      </tr>
        {/*Start File*/}
      <tr>
        <td>10-20-2026</td>
        <td>N/A</td>
        <td>
          <a href="../docs/council/minutes/2026/2026-10-20-BCAgenda.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
      </tr>
      {/*End File*/}
       {/*Start File*/}
      <tr>
        <td>10-01-2026</td>
        <td>N/A</td>
        <td>
          <a href="../docs/council/minutes/2026/2026-10-01-BCAgenda.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
      </tr>
      {/*End File*/}
       {/*Start File*/}
      <tr>
        <td>9-15-2026</td>
        <td>N/A</td>
        <td>
          <a href="../docs/council/minutes/2026/2026-09-15-BCAgenda.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
      </tr>
      {/*End File*/}
        {/*Start File*/}
      <tr>
        <td>8-18-2026</td>
        <td>N/A</td>
        <td>
          <a href="../docs/council/minutes/2026/2026-08-18-BCAgenda.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
      </tr>
      {/*End File*/}
        {/*Start File*/}
      <tr>
        <td>7-21-2026</td>
        <td>N/A</td>
        <td>
          <a href="../docs/council/minutes/2026/2026-07-21-BCAgenda.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>6-16-2026</td>
          <td>
          <a href="../docs/council/minutes/2026/2026-06-16-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>
          <a href="../docs/council/minutes/2026/2026-06-16-BCAgenda.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>5-20-2026</td>
         <td>
          <a href="../docs/council/minutes/2026/2026-05-20-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>
          <a href="../docs/council/minutes/2026/2026-05-20-BCAgenda.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>4-21-2026</td>
         <td>
          <a href="../docs/council/minutes/2026/2026-04-21-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>
          <a href="../docs/council/minutes/2026/2026-04-21-BCAgenda.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>3-17-2026</td>
         <td>
          <a href="../docs/council/minutes/2026/2026-03-17-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>
          <a href="../docs/council/minutes/2026/2026-03-17-BCAgenda.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>2-17-2026</td>
        <td>
          <a href="../docs/council/minutes/2026/2026-02-17-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>
          <a href="../docs/council/minutes/2026/2026-02-17-BCAgenda.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>1-20-2026</td>
        <td>
          <a href="../docs/council/minutes/2026/2026-01-20-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>
          <a href="../docs/council/minutes/2026/2026-01-20-BCAgenda.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>1-5-2026</td>
        <td>
          <a href="../docs/council/minutes/2026/2026-01-05-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
        <td>
          <a href="../docs/council/minutes/2026/2026-01-05-BCAgenda.pdf" target="_blank" rel="noopener noreferrer">
            <i className="fa-solid fa-file-pdf fa-xl"></i>
            &nbsp; Available
          </a>
        </td>
      </tr>
      {/*End File*/}
    </table>
  );
}
